import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function EnquiriesList() {
  const { data: enquiries = [], isLoading } = useQuery({
    queryKey: ["enquiries"],
    queryFn: async () => (await api.get("/admin/enquiries")).data,
  });

  if (isLoading) return <p className="text-sm text-mist">Loading…</p>;

  return (
    <div data-testid="admin-enquiries">
      <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-mist" data-testid="admin-enquiries-count">{enquiries.length} enquiries</p>
      <div className="divide-y divide-navy-ink/10 border border-navy-ink/10 bg-white/40">
        {enquiries.map((e) => (
          <div key={e.enquiry_id} className="p-5" data-testid={`admin-enquiry-${e.enquiry_id}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="font-serif text-lg text-navy-ink">{e.name} <span className="text-sm text-mist">· {e.email}{e.phone ? ` · ${e.phone}` : ""}</span></p>
              <p className="text-[10px] uppercase tracking-[0.3em] text-mist">{new Date(e.created_at).toLocaleString("en-IN")}</p>
            </div>
            <p className="mt-1 break-all text-[10px] uppercase tracking-[0.3em] text-gold">{e.interest || "General"}{e.source && <span className="ml-3 normal-case tracking-normal text-mist" data-testid="enquiry-source">via {e.source}</span>}</p>
            <p className="mt-2 text-sm font-light text-navy-ink/80">{e.message}</p>
          </div>
        ))}
        {enquiries.length === 0 && <p className="p-8 text-sm text-mist">No enquiries yet.</p>}
      </div>
    </div>
  );
}
